import InputContainer from '../input'
import SelectContainer from '../select/SelectContainer'
import RadioContainer from '../radio/RadioContainer'
import React from 'react'
import DatePickerContainer from '../datePicker/DatePickerContainer'

function FieldForProp({
  prop,
  withInfo,
  value,
  onValueChange,
  controlled,
  disabled,
}) {
  const handleInputChange = (e) => {
    onValueChange?.(e)
  }
  const handleSelectChange = (e) => {
    onValueChange?.(e)
  }
  const handleRadioChange = (e) => {
    onValueChange?.(e)
  }

  const handleDateChange = (e) => {
    onValueChange?.(e)
  }

  const labelFromProp = (prop) => `${prop.required ? '* ' : ''}${prop.title}`

  switch (prop.type) {
    case 'string':
    case 'number':
      return (
        <InputContainer
          onInputChange={handleInputChange}
          label={`${prop.required ? '* ' : ''}${prop.title}`}
          info={withInfo ? prop.description : ''}
          type={prop.type}
          isDisabled={disabled}
          {...(controlled
            ? {
                value: value,
              }
            : {
                defaultValue: value,
              })}
        />
      )
    case 'textarea':
      return (
        <InputContainer
          onInputChange={handleInputChange}
          label={labelFromProp(prop)}
          info={withInfo ? prop.description : ''}
          textArea={true}
          defaultValue={value}
        />
      )
    case 'select':
      return (
        <SelectContainer
          label={labelFromProp(prop)}
          options={prop.options}
          onSelectChange={handleSelectChange}
          formKey={prop.key}
          info={withInfo ? prop.description : ''}
          defaultValue={value}
        />
      )
    case 'radio':
      return (
        <RadioContainer
          options={prop.options}
          title={prop.title}
          info={withInfo ? prop.description : ''}
          formKey={prop.key}
          defaultValue={value}
          onRadioChange={handleRadioChange}
        />
      )
    case 'date':
      return (
        <DatePickerContainer
          label={prop.title}
          info={withInfo ? prop.description : ''}
          formKey={prop.key}
          defaultValue={value}
          onDateChange={handleDateChange}
        />
      )
    default:
      return <div>unimplemented form field type</div>
  }
}

export default FieldForProp
